import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Search from "../../shared-components/Search/Search";
import styles from "./Table.module.css";

const Table = ({
  columns,
  Dealers,
  handleEdit,
  handleDelete,
  query,
  setquery,
}) => {
  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const totalPages = Math.ceil(Dealers?.length / itemsPerPage);


  console.log("dealer", Dealers)

  useEffect(() => {
    const updatedFilteredUsers = query
      ? Dealers.filter((dealer) =>
        dealer.dealershipId?.dealershipName
          ?.toLowerCase()
          .includes(query.toLowerCase())
      )
      : [];
    setFilteredUsers(updatedFilteredUsers);
  }, [query, Dealers]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Dealers?.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };
  const [deployedDeals, setDeployedDeals] = useState([]);
  const generateUrl = (customer) => {

    // return `${process.env.REACT_APP_BASE_URL}/board/?deal=${customer}`;
    return `https://admin.provaantech.com/pitch-aimee-board/?deal=${customer}`;
  };
  const handleDeployClick = (dealId) => {
    if (!deployedDeals.includes(dealId)) {
      setDeployedDeals((prev) => [...prev, dealId]);
    }
  };

  const renderTableRows = (dealers) =>
    dealers.map((dealer, index) => {
      const sequentialId = (currentPage - 1) * itemsPerPage + (index + 1); // Calculate global index
      return (
        <tr key={sequentialId}>
          <td>{sequentialId}</td> {/* Use sequential ID */}
          <td className={styles.profileImgContainer}>
            {dealer?.dealershipName || "N/A"}
          </td>
          <td>
            {dealer?.multiStepProcessId ? <div className={styles.buttonContainer}>
              {deployedDeals.includes(dealer?._id) ? (
                <a
                  href={generateUrl(dealer?._id)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {generateUrl(dealer?._id)}
                </a>
              ) : (
                <button
                  className={styles.dealDeployButton}
                  onClick={() => handleDeployClick(dealer?._id)}
                >
                  Deploy Avatar
                </button>
              )}
            </div> : "Not Avilable"}
          </td>
          <td>
            {dealer?.multiStepProcessId ? <div className={styles.EditButtons}>
              <a
                href={`/pitch-aimee?multiStepProcessId=${dealer?.multiStepProcessId}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Edit Stepper
              </a>
            </div> : <div className={styles.EditButton}>
              <a
                href={`/pitch-aimee?dealershipId=${dealer?._id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Add Stepper
              </a>
            </div>}
          </td>
          <td>
            <div className={styles.buttonContainer}>
              <button
                onClick={() => handleEdit(dealer)}
                className={`${styles.button} ${styles.edit}`}
              >
                <FaEdit />
              </button>
              <button
                onClick={() => handleDelete(dealer._id)}
                className={`${styles.button} ${styles.delete}`}
              >
                <MdDelete />
              </button>
            </div>
          </td>
        </tr>
      );
    });

  const displayItems =
    query && filteredUsers.length > 0
      ? filteredUsers
      : query
        ? []
        : currentItems;

  return (
    <div className={styles.Container}>
      <Search
        query={query}
        setquery={setquery}
        placeholder="Search for Dealer Name"
      />
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              {columns.map(({ name }, index) => (
                <th key={index} className={styles.int_dealershipform_th}>{name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {displayItems?.length === 0 ? (
              <tr>
                <td colSpan={columns.length}>
                  {query ? "No results found" : "No data available"}
                </td>
              </tr>
            ) : (
              renderTableRows(displayItems)
            )}
          </tbody>
        </table>
      </div>
      {!query && (
        <div className={styles.pagination}>
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className={styles.paginationButton}
          >
            Prev
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => handlePageChange(index + 1)}
              className={`${styles.paginationButton} ${currentPage === index + 1 ? styles.dealactive : ""
                }`}
            >
              {index + 1}
            </button>
          ))}
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className={styles.paginationButton}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Table;
